import useUser from '../global/useUser';
import { LoadedUser } from '../../interfaces';

function useInventoryEnabled() {
  const { user } = useUser<LoadedUser>();
  return !!user?.business?.inventoryEnabled;
}

export default useInventoryEnabled;
